import BaseApi from '../base/base'
import Notification from '../../models/notification'

export default class NotificationApi extends BaseApi {
  constructor () {
    super()
    this.path = '/notifications'
  }

  async get (params: {checkNotification: boolean} = {checkNotification: false}): Promise<{notifications: Notification[], unread: number}> {
    this.path = '/notifications'
    const response = await this.getRequest(params)
    return {
      notifications: response.data.notifications.map(element => {
        return new Notification(element)
      }),
      unread: response.data.unread
    }
  }

  async markReaded(id: number){
    this.path = `/notifications/${id}/mark_readed`
    const response = await this.postRequest({})
    return true
  }
}
